import { FC, ReactElement, useContext } from 'react';

import KobaiDefaultLogo from './Theme/KobaiDefaultLogo';
import ErrorBoundary from '../../../components/ErrorBoundary/ErrorBoundary';
import HomeContent from './HomeContent';
import ThemedSpinner from './Theme/ThemedSpinner';
import ThemedGradient from './Theme/ThemedGradient';
import { context } from '../../../components/Theme/Context';
import './HomeContainer.css';

const AppLoading: FC = (): ReactElement<any> => {
  const theme = useContext(context);

  return (
    <div className={`home is-loading vh-100 flex-column bg-fafafa Roboto flex w-100 items-center`}>
      <section data-testid="loading-container" className="home-container mt5 flex bg-white">
        <article
          className="home-messaging pa4 flex-column relative flex items-center overflow-hidden"
          style={{
            color: theme.colors.foreground,
          }}
        >
          <KobaiDefaultLogo />

          <ThemedSpinner isVisible={true} />

          <ThemedGradient />
        </article>
        <ErrorBoundary>
          <HomeContent>
            <></>
          </HomeContent>
        </ErrorBoundary>
      </section>

      <footer className="mt4 fw1 flex w-100 justify-center">
        <span>© {new Date().getFullYear()} Kobai Inc.</span>
      </footer>
    </div>
  );
};
export default AppLoading;
